import { CSSProperties } from 'react';
import styled from 'styled-components';

import { TSpacing, TTypography } from './types';

import { customMarginStyles, customPaddingStyles } from '../../../styles/Shared/SharedStyles';
import { handleTypography } from '../../../styles/Shared/TypographyStyles';
import Theme from '../../../styles/Theme/Theme';

type WeightKeys = keyof typeof Theme.typography.weight;

type HeadingProps = {
    customColor?: keyof typeof Theme.color;
    size?: keyof typeof Theme.typography.size;
    weight?: typeof Theme.typography.weight[WeightKeys];
    level: 1 | 2 | 3 | 4 | 5 | 6;
};

export const Heading = styled('h1').attrs<HeadingProps & CSSProperties>(({ level }) => ({
    as: `h${level}`
})) <HeadingProps & TTypography & TSpacing & CSSProperties>`
    ${customMarginStyles}
    ${customPaddingStyles}
    width: ${({ width }) => (width ? width : null)};
    text-align: ${({ textAlign }) => (textAlign ? textAlign : null)};
    color: ${({ color, customColor, theme }) => {
        if (customColor) return theme.color[customColor];
        return color;
    }};
    ${(props: TTypography) => handleTypography(props)};
`